module.exports = __webpack_public_path__ + "img/invoice.74a8630d.jpg";